/**
 * 앱 관리 (page-partner-app.php) — 읽기 전용 현황판.
 *
 * - 좌측 섹션 메뉴([data-app-nav], 모바일은 상단 칩): 프로필 · /register/ 와 같은 방식으로 카드의 data-nav-label 을 모아 채운다.
 * - 양식 설정 열기([data-wizard-link]): 고객센터와 같은 통행 링크(initPartnerSupport.js 의 initWizardLinks) 로
 *   매장 사이트 양식 설정 화면을 새 창에 연다. admin-ajax 주소 · nonce 는 루트([data-partner-app])의 data 속성에 있다.
 */

import { initWizardLinks } from './initPartnerSupport';
import initScrollSpyNav from './scrollSpyNav';

const InitPartnerApp = () => {
  const root = document.querySelector('[data-partner-app]');

  if (!root) {
    return;
  }

  const navEl = document.querySelector('[data-app-nav]');

  if (navEl) {
    initScrollSpyNav(
      navEl,
      Array.from(root.querySelectorAll('[data-nav-label]')).map((section) => ({
        el: section,
        label: section.dataset.navLabel,
      }))
    );
  }

  initWizardLinks(root);
};

export default InitPartnerApp;
